import { PAYMENT_METHOD_TYPE } from '../paymentMethodType.ts';

export const getChargeIsPixInstallment = (charge: unknown) => {
  if (!charge?.isPaymentIntent) {
    return false;
  }

  const hasPaymentMethodSelected =
    charge?.paymentMethods && charge?.paymentMethods.length > 0;

  if (!hasPaymentMethodSelected) {
    return false;
  }

  if (charge?.paymentMethods.length === 1) {
    return (
      charge?.paymentMethods[0]?.method === PAYMENT_METHOD_TYPE.PIX_CREDIARY
    );
  }

  return charge?.paymentMethods.find(
    (pm) => pm.method === PAYMENT_METHOD_TYPE.PIX_CREDIARY,
  );
};
